module.exports = __webpack_public_path__ + "static/media/icon_fb.09420e97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/icon_fb.svg
// module id = 152
// module chunks = 0